import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditPurchesh = () => {
    const { id } = useParams(); // Get the Purchesh ID from URL params
    const [vepariId, setVepariId] = useState('');
    const [pcsWeight, setPcsWeight] = useState('');
    const [price, setPrice] = useState('');
    const [total, setTotal] = useState('');
    const [image, setImage] = useState(null);
    const navigate = useNavigate();

    // Fetch Purchesh data on component mount
    useEffect(() => {
        fetch(`${BASE_URL}purcheshes/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const { vepari_id, pcs_weight, price, total, image } = data.data;
                    setVepariId(vepari_id);
                    setPcsWeight(pcs_weight);
                    setPrice(price);
                    setTotal(total);
                    setImage(image); // Existing image URL
                } else {
                    console.error('Error fetching purchesh:', data.message);
                }
            })
            .catch(error => console.error('Error:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const purcheshData = new FormData();
        purcheshData.append('staff_id', '1'); // Assuming staff_id is static for now
        purcheshData.append('vepari_id', vepariId);
        purcheshData.append('pcs_weight', pcsWeight);
        purcheshData.append('price', price);
        purcheshData.append('total', total);
        if (image) purcheshData.append('image', image);

        fetch(`${BASE_URL}purcheshes/${id}`, {
            method: 'PUT',
            body: purcheshData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    // Redirect to Purchesh List after successful update
                    navigate('/PurcheshesList');
                } else {
                    console.error('Error updating purchesh:', data.message);
                }
            })
            .catch(error => console.error('Error:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Purchesh</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4>Edit Purchesh Details</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/PurcheshesList')}>Back to List</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="vepariId" className="form-label">Vepari ID</label>
                                        <input
                                            type="text"
                                            id="vepariId"
                                            className="form-control"
                                            value={vepariId}
                                            onChange={(e) => setVepariId(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pcsWeight" className="form-label">PCS Weight</label>
                                        <input
                                            type="number"
                                            id="pcsWeight"
                                            className="form-control"
                                            value={pcsWeight}
                                            onChange={(e) => setPcsWeight(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="price" className="form-label">Price</label>
                                        <input
                                            type="number"
                                            id="price"
                                            className="form-control"
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="total" className="form-label">Total</label>
                                        <input
                                            type="number"
                                            id="total"
                                            className="form-control"
                                            value={total}
                                            onChange={(e) => setTotal(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Upload Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                        {image && <img src={`${BASE_URL}${image}`} alt="current" width="100" />}
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-success">Update Purchesh</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPurchesh;
